export default function getUserIdFromOkta() {
  return (
    JSON.parse(localStorage.getItem('okta-token-storage') ?? '{}').accessToken
      ?.claims?.uid || ''
  );
}
